import PopularDestinationsWrapper from './PopularDestinationsWrapper';

export default PopularDestinationsWrapper;
